export default {
  setPower(state, power) {
    state.hasPower = power
  },
  setLevels(state, levels) {
    state.levels = levels
  },
  setHalls(state, halls) {
    state.halls = halls
  }
}
